<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Utwórz nowe zgłoszenie</h4>
              <Link :href="route('service.index')" class="btn btn-outline-primary">
                <i class="bi bi-list"></i>&nbsp;Lista zgłoszeń
              </Link>
            </div>
          </div>
        </div>

        <div class="widget-content">
          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>

          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="row">
                <h4 class="me-3 my-0 mb-2">Dane kontrahenta</h4>
                <form @submit.prevent="submitForm">

                  <!-- Wybór klienta -->
                  <div class="row">
                    <div class="col-md-4 col-lg-6">
                      <div v-if="form.customer_id !== undefined" class="container-fluid">
                        <label class="form-label" for="customer_id">Klient*:</label>
                        <select v-model="form.customer_id" class="select2 form-select w-100" id="sel_customer_id">
                          <option v-for="customer in customers" :key="customer.id" :value="customer.id">
                            {{ customer.name }}
                          </option>
                        </select>
                        <div v-if="form.errors.customer_id" class="text-danger">{{ form.errors.customer_id }}</div>
                      </div>
                      <div>
                        <Link href="/customers/create" class="btn btn-outline-primary mt-2 ms-2">
                          <i class="bi bi-plus"></i> Dodaj kontrahenta
                        </Link>
                      </div>
                    </div>

                    <!-- Wybór projektu -->
                    <div class="col-md-4 col-lg-6">
                      <div v-if="form.project_id !== undefined" class="container-fluid">
                        <label class="form-label" for="project_id">Projekt*:</label>
                        <div v-if="form.errors.project_id">{{ form.errors.project_id }}</div>
                        <select v-model="form.project_id" class="select2 form-select w-100" id="sel_project_id">
                          <option v-for="project in filteredProjects" :key="project.id" :value="project.id">
                            {{ project.number }} - {{ project.name }}
                          </option>
                        </select>
                        <div v-if="form.errors.project_id" class="text-danger">{{ form.errors.project_id }}</div>
                      </div>
                      <div>
                        <Link href="/projects/create" class="btn btn-outline-primary mt-2 ms-2">
                          <i class="bi bi-plus"></i> Dodaj projekt
                        </Link>
                      </div>
                    </div>
                  </div>
                  <br><h4 class="me-3 t-3 my-0 mb-0">Adres instalacji</h4>
                  <div class="row">

                    <!-- Adres instalacji -->
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="delivery_zip_code">Kod pocztowy:</label>
                      <input type="text" id="delivery_zip_code" class="form-control form-control-sm"
                             v-model="form.delivery_zip_code"/>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="delivery_city">Miasto:</label>
                      <input type="text" id="delivery_city" class="form-control form-control-sm"
                             v-model="form.delivery_city"/>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="delivery_street">Ulica:</label>
                      <input type="text" id="delivery_street" class="form-control form-control-sm"
                             v-model="form.delivery_street"/>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="delivery_apartment">Lokal:</label>
                      <input type="text" id="delivery_apartment" class="form-control form-control-sm"
                             v-model="form.delivery_apartment"/>
                    </div>
                  </div>
                  <h4 class="me-3 my-0 mb-0">Osoba zgłaszająca</h4>
                  <div class="row">
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="ticket_person">Imię i Nazwisko:</label>
                      <input type="text" id="ticket_person" class="form-control form-control-sm"
                             v-model="form.ticket_person"/>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="ticket_phone">Telefon:</label>
                      <input type="text" id="ticket_phone" class="form-control form-control-sm"
                             v-model="form.ticket_phone"/>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="ticket_email">E-mail:</label>
                      <input type="text" id="ticket_email" class="form-control form-control-sm"
                             v-model="form.ticket_email"/>
                    </div>
                  </div>
                  <h4 class="me-3 my-0 mb-0">Zgłoszenie</h4>
                  <div class="row">
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="created_at">Data zgłoszenia:</label>
                      <input type="date" id="created_at" class="form-control form-control-sm"
                             v-model="form.created_at"/>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="created_at">Kategorie serwisu:</label>
                      <Vueform>
                        <TagsElement
                            name="serviceCategories"
                            :native="false"
                            value-prop="id"
                            label-prop="name"
                            :items="serviceCategories"
                            :default="form.service_category_ids"
                            @change="changeServiceCategories"
                        />
                      </Vueform>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-6 col-lg-6 mb-6">
                      <label class="form-label" for="description">Treść zgłoszenia:</label>
                      <div v-if="form.errors.description">{{ form.errors.description }}</div>
                      <textarea class="form-control form-control-sm" id="description" v-model="form.description"
                                rows="4"></textarea>
                    </div>
                  </div>
                  <br><h4 class="me-3 my-0 mb-0">Pliki</h4>
                  <div class="row">
                    <div class="col-md-6 col-lg-6 mb-6">
                      <div>
                        <label for="attachments">Dodaj pliki:</label>
                        <input
                            type="file"
                            id="attachments"
                            multiple
                            @change="handleFileUpload"
                            class="form-control form-control-sm"
                        />
                      </div>

                      <div v-if="form.attachments.length">
                        <p>Załączone pliki:</p>
                        <ul>
                          <li v-for="(file, index) in form.attachments" :key="index">
                            {{ file.name }}
                            <button type="button" class="btn btn-danger mt-3" @click="removeFile(index)">Usuń</button>
                          </li>
                        </ul>
                      </div>


                    </div>
                  </div>


                  <template v-if="!isLoading">
                    <button class="btn btn-primary mt-3" type="submit"
                            :disabled="isLoading || !form.customer_id || !form.project_id">
                      Zapisz
                    </button>
                  </template>

                  <template v-if="isLoading">
                    <div class="mt-4 spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">
                      Ładowanie...
                    </div>
                  </template>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import {useForm} from "@inertiajs/vue3";
import AppLayout from "@/Layouts/App.vue";
import {ref} from "vue";
import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
import {router} from "@inertiajs/vue3";
import {Tooltip} from 'bootstrap';
import {isDisabled} from "bootstrap/js/src/util/index.js";

export default {
  components: {AppLayout},
  props: {
    service: {
      type: Object,
      required: true,
      default: () => ({
        project_id: null,
        customer_id: null,
        description: '',
        attachments: [],
      })
    },
    projects: Array,
    customers: {
      type: Array,
      default: () => []
    },
    serviceCategories: Array
  }
  ,
  data() {
    return {
      isLoading: false,
      form: {
        name: null,
        description: null,
        project_id: null,
        customer_id: null,
        delivery_street: null,
        delivery_zip_code: null,
        delivery_city: null,
        delivery_apartment: null,
        ticket_person: null,
        ticket_phone: null,
        ticket_email: null,
        created_at: null,
        service_category_ids: [],
        description: '',
        attachments: [],
        errors: {}
      },
      filteredProjects: [],
    };
  },
  watch: {
    "form.customer_id"(newCustomerId) {
      this.filterProjects(newCustomerId);
    },
    "form.project_id"(newProjectId) {
      this.fetchProjectDetails(newProjectId);
    }
  },
  mounted() {
    this.handleSelect2();
    this.form.created_at = this.getTodayDate();
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    });

    if (this.form.customer_id) {
      this.filterProjects(this.form.customer_id);
    } else {
      this.filteredProjects = this.projects;
    }
  },
  methods: {
    changeServiceCategories(selectedCategories) {
      this.form.service_category_ids = selectedCategories;
    },
    getTodayDate() {
      const today = new Date();
      return today.toISOString().split("T")[0];
    },
    handleSelect2() {
      $('#sel_customer_id').select2().on('select2:select', (e) => {
        this.form.customer_id = parseInt(e.params.data.id);
        this.filterProjects(this.form.customer_id);
      });

      $('#sel_project_id').select2().on('select2:select', (e) => {
        this.form.project_id = parseInt(e.params.data.id);
        console.log("Zmieniono projekt na:", this.form.project_id);
        this.fetchProjectDetails(this.form.project_id);
      });
    },

    filterProjects(customerId) {
      const id = Number(customerId);
      this.filteredProjects = this.projects.filter(project => Number(project.customer_id) === id);
      this.form.project_id = null;

      this.$nextTick(() => {
        $('#sel_project_id').select2();
      });
    },

    handleFileUpload(event) {
      for (let file of event.target.files) {
        this.form.attachments.push(file);
      }
    },
    removeFile(index) {
      this.form.attachments.splice(index, 1);
    },

    async submitForm() {
      this.form.errors = {};

      if (!this.form.customer_id) {
        this.form.errors.customer_id = "Wybór klienta jest wymagany.";
      }
      if (!this.form.project_id) {
        this.form.errors.project_id = "Wybór projektu jest wymagany.";
      }

      if (Object.keys(this.form.errors).length > 0) {
        return;
      }

      this.isLoading = true;

      let formData = new FormData();

      Object.keys(this.form).forEach((key) => {
        if (key === "attachments") {
          this.form.attachments.forEach((file, index) => {
            formData.append(`attachments[${index}]`, file);
          });
        } else if (key === "service_category_ids" && Array.isArray(this.form[key])) {
          this.form[key].forEach((id, index) => {
            formData.append(`service_category_ids[${index}]`, id);
          });
        } else {
          formData.append(key, this.form[key]);
        }
      });

      try {
        await router.post(route('service.store'), formData);
      } catch (error) {
        console.error("Błąd zapisu:", error);
      }

      this.isLoading = false;
    }
    ,
    async fetchProjectDetails(projectId) {
      if (!projectId) return;

      try {
        const response = await fetch(`/projects/projects/${projectId}/details`);
        if (!response.ok) {
          throw new Error("Nie udało się pobrać danych projektu.");
        }

        const data = await response.json();
        console.log("Dane pobrane z backendu:", data);

        this.form.delivery_street = data.delivery_street || "";
        this.form.delivery_zip_code = data.delivery_zip_code || "";
        this.form.delivery_city = data.delivery_city || "";
        this.form.delivery_apartment = data.delivery_apartment || "";
      } catch (error) {
        console.error("Błąd pobierania danych projektu:", error);
      }
    }


  }
};
const changeServiceCategories = (newVal) => {
  form.service_categories = newVal;
}
</script>


<style scoped>
.tooltip {
  opacity: 1 !important;
}
</style>
